import { createTestIds } from '../../utils';

export const getEmptyStateTestIds = createTestIds('empty-state', ['message', 'icon'] as const);
